import { render, staticRenderFns } from "./comp-6.vue?vue&type=template&id=4a746bc8"
import script from "./comp-6.vue?vue&type=script&lang=js"
export * from "./comp-6.vue?vue&type=script&lang=js"
import style0 from "./comp-6.vue?vue&type=style&index=0&id=4a746bc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports